import React from 'react';
import { styled } from 'styled-components';
import { css } from '/imports/ui/css';

const TabsStyled = styled.div`
  display: flex;
  justify-content: center;
  font-weight: 500;
  background: ${css.grey9};
  border: 1px solid ${css.grey7};
  border-radius: 0.75rem;
  .tab {
    padding: 0.25rem 1rem;
    margin: 0.1rem;
    border-radius: 0.75rem;
    cursor: pointer;
    text-align: center;
    &.active {
      color: ${css.white};
      background: ${css.primaryColor};
    }
  }
  @media only screen and (max-width: 400px) {
    width: 100%;
    flex-direction: column;
  }
`;

interface TabProps {
  label: string;
  active?: boolean;
  onClick?(): void;
  key?: string;
}

interface TabsProps {
  tabs: TabProps[];
  tabWidth?: string;
}

/** Horizontal tab bar that highlights the active tab and fires onClick per tab. */
export const Tabs = (props: TabsProps) => (
  <TabsStyled className="tabs">
    {
      props.tabs.map((tab) => (
        <div key={tab.key || tab.label} className={tab.active ? 'tab active' : 'tab'} style={props.tabWidth ? { width: props.tabWidth } : {}} onClick={() => tab.onClick?.()}>
          {tab.label}
        </div>
      ))
    }
  </TabsStyled>
);